<div>
  <app-hospital-privilege *ngFor="let hospitalPrivilege of hospitalPrivilegeDetails" [dynamicForm] = "dynamicForm" [hospitalPrivilegeDetail]="hospitalPrivilege" (componentDeleted)="onComponentDeleted($event)" (componentChanged)="onComponentChange($event)" [fieldsPrerequisite]="fieldsPrerequisite"></app-hospital-privilege>
</div>
<button class="btn btn--solid" (click)="addHospital()">ADD HOSPITAL</button>
